import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Checkbox, ConfigProvider, DatePicker, Form, Input, InputNumber, Radio} from "antd";
import dayjs from "dayjs";

import {LONGDATE} from "../../../../../../assets/scripts/constants";
import useMortgage from "../../../../../providers/mortgage/useMortgage";
import useMortgageUploadService from "../../../../../providers/mortgage/useMortgageUploadService";
import {LoadingOutlined, MinusCircleOutlined} from "@ant-design/icons";
import {Auth} from "aws-amplify";
import 'dayjs/locale/en-ie'
import {red} from "@ant-design/colors";
import useBackendUsers from "../../../../../providers/mortgage/useBackendUsers";
import {AdjustmentDirections} from "../../../../../../models";
import {onPasteAppendFloat} from "../../../../tools-drawer/query/InstaQuery";

dayjs.locale('en-ie')
QueryItemForm.propTypes = {
    item: PropTypes.object.isRequired
};

function QueryItemForm(props) {
    const mortgage = useMortgage()
    const uploadService = useMortgageUploadService()
    const {getBySub} = useBackendUsers()
    const [state, setState] = useState({editing: false, saving: false})
    const dateDefault = props.item.date ? dayjs(props.item.date, "YYYY-MM-DD") : null

    const initialValues = {
        date: props.inExtWindow ? dateDefault?.format("YYYY-MM-DD") : dateDefault,
        title: props.item.title,
        description: props.item.description,
        query: props.item.query.join('\n'),
        private: !!props.item.private,
        userAnswer: props.item.userAnswer ? props.item.userAnswer.join('\n') : "",
        exclude: !!props.item.excludedBy,
        amount: props.item.amount,
        userAnswered: !!props.item.userAnswered,
        adminAnswered: !!props.item.adminAnswered,
        lenderAnswer: props.item.lenderAnswer ? props.item.lenderAnswer.join('\n') : "",
        reoccurring: props.item.reoccurring || false,
        adjustmentDirection: props.item.adjustmentDirection || null,
        adjustmentAmount: props.item.adjustmentAmount || "",
        adjustmentList: (props.item.adjustmentList || [] ).filter(n=>n!==null) .map(it=> it.toFixed(2) + '\n').join('') || ""
    }


    const handleDelete = async () => {

        await mortgage.mutate({
            delete: {
                target: `queries`,
                id: props.item.id
            }
        })

    }
    const handleLenderAnswerSave = async (form) => {

        setState(s => ({...s, saving: true}))
        const user = await Auth.currentAuthenticatedUser()
        const update = {
            target: `queries[${props.item.id}]`,
            pairs: {
                query: form.query.split('\n'),
                description: form.description,
                title: form.title,
                date: form.date ? props.inExtWindow ? form.date : form.date.format('YYYY-MM-DD') : null,
                amount: form.amount ? form.amount : null,
                excludedOn: form.exclude ? (new Date()).toISOString() : null,
                excludedBy: form.exclude ? user.attributes.sub : null,
                private: form.private,
                lenderAnswer: form.lenderAnswer ? form.lenderAnswer.split('\n') : null,
                reoccurring: form.reoccurring || null,
                adjustmentDirection: form.adjustmentDirection || null,
                adjustmentAmount: form.adjustmentAmount || null,
                adjustmentList: form.adjustmentList ? form.adjustmentList.split(/[^\d.]+/).filter(part => part.trim() !== '').map(part => parseFloat(part)) : null
            }
        }
        if (!!form.lenderAnswer && !props.item.adminAnswered) {
            update.pairs.lenderAnswerOn = (new Date()).toISOString()
            update.pairs.lenderAnswerBy = user.attributes.sub
            update.pairs.adminAnswered = 1
        }

        await mortgage.mutate({update})
        setState(s => ({...s, saving: false}))
        if (props.afterSave){
            props.afterSave()
        }
    }

    function LinkToItem() {
        switch (props.item.referenceType) {
            case "UPLOAD":
                const upload = mortgage.uploads.find(it => it.id === props.item.referenceId)
                if (upload) {
                    const handleUploadOpen = async () => {
                        await uploadService.open(upload)
                    }
                    return (
                        <Form.Item
                            label="File"
                        >
                            <a onClick={handleUploadOpen}>{upload.fileName}</a>
                        </Form.Item>
                    )
                }
                return null

            default:
                return null
        }

    }

    function DeleteConfirm() {
        return <Button danger
            // title="Delete the task"
            // description="Are you sure to delete this query?"
            // okText="Delete"
            //onConfirm={handleDelete}
                       onClick={handleDelete}
                       icon={
                           <MinusCircleOutlined
                               style={{
                                   color: red.primary,
                               }}
                           />
                       }
        >
            Delete
        </Button>
    }

    const [form] = Form.useForm();
    const onAdjustmentListBlur = (e) => {
        const adjustmentList = form.getFieldValue('adjustmentList') || "";
        const reoccurring = form.getFieldValue('reoccurring') || false;
        const adjustmentDirection = form.getFieldValue('adjustmentDirection') || "";
        if (reoccurring && !!adjustmentDirection && !!adjustmentList) {
            // is there a preexisting - set the adjustmentList to the existing adjustment amount

            const parts = adjustmentList.split(/[^\d.]+/).filter(part => part.trim() !== '').map(part => parseFloat(part));

            const sum = parts.reduce((acc, val) => acc + val, 0).toFixed(2);
            form.setFieldsValue({
                adjustmentAmount: sum,
                adjustmentList: parts.map(part => part.toFixed(2)).join('\n') + '\n'
            })
        }
    }
    const handleRecurringChange = (e) => {

        // reevaluate the adjustmentList for all drafts
        const reoccurring = e.target.checked

        const adjustmentList = form.getFieldValue('adjustmentList') || false;
        const adjustmentAmount = form.getFieldValue('adjustmentAmount') || "";
        const queryText = form.getFieldValue('query') || "";
        const date = form.getFieldValue('date') || null;
        const year = date ? dayjs(date).year() : null;


        if (reoccurring && !adjustmentList && !!adjustmentAmount) {
            const newAdjListValue = adjustmentAmount.toString() + '\n';

            form.setFieldValue('adjustmentList', newAdjListValue );
            if (queryText?.endsWith(`${year}.`)){
                let newQueryText = queryText.slice(0, -1)
                form.setFieldValue('query', newQueryText + ` and other dates.`);
            }
        }
        else if (!reoccurring && !!adjustmentList) {
            const parts = adjustmentList.split(/[^\d.]+/).filter(part => part.trim() !== '').map(part => parseFloat(part))
            form.setFieldValue('adjustmentAmount', parts[0].toFixed(2) )
            form.setFieldValue('adjustmentList',  '');
            if (queryText?.endsWith(` and other dates.`)){
                let newQueryText = queryText.replace(` and other dates.`,'.')
                form.setFieldValue('query', newQueryText);
            }
        }
    }

    return (
        <ConfigProvider
            key={JSON.stringify(initialValues)}
            theme={{
                components: {
                    Form: {
                        labelColor: '#8c8c8c'
                    },
                },
            }}
        >

            <Form
                form={form}
                requiredMark={false}
                initialValues={initialValues}
                onFinish={handleLenderAnswerSave}
                // labelCol={{span:8}}
                // wrapperCol={{span:16}}
            >
                <Form.Item
                    label="Answer by User"
                    name={"userAnswer"}
                >
                    <Input.TextArea autoSize readOnly/>
                </Form.Item>
                <Form.Item
                    label="Cover Note Text"
                    name="lenderAnswer"
                >
                    <Input.TextArea autoSize
                    />
                </Form.Item>

                <div className="d-row j-equal grow gap-24 f-wrap">
                    <div>
                        <Form.Item
                            label="Cover Note Title"
                            name="title">
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name="date"
                            label="Date">
                            {props.inExtWindow ? <Input type="date"/> : <DatePicker format={"D MMM YYYY"}/>}
                        </Form.Item>
                        <Form.Item
                            name="amount"
                            label="Amount">
                            <InputNumber style={{width: '100%'}} prefix="€"/>
                        </Form.Item>


                    </div>

                    <div>
                        <div className="d-row j-end">
                            <div className="me-auto">
                                Created
                                By: {getBySub(props.item.createdBy).firstName} on {dayjs(props.item.createdAt).format(LONGDATE)}
                            </div>

                        </div>
                        <Form.Item
                            className="mb-0"
                            name="exclude"
                            valuePropName="checked"
                        >
                            <Checkbox> Exclude from cover note</Checkbox>

                        </Form.Item>
                        <Form.Item
                            className="mb-0"
                            name="private"
                            valuePropName="checked"
                        >
                            <Checkbox
                                //    defaultChecked={!!props.item.private}
                            >Hide from user</Checkbox>

                        </Form.Item>

                        <div className="d-row a-center j-between">
                            Adjust Savings Rate:
                            <Form.Item className="mb-0" name='adjustmentDirection'>
                                <Radio.Group
                                    options={[
                                        {value: AdjustmentDirections.UP, label: 'Up'},
                                        {value: AdjustmentDirections.DOWN, label: 'Down'},
                                        {value: null, label: 'None'},
                                    ]}
                                />
                            </Form.Item>
                        </div>

                        <Form.Item noStyle shouldUpdate={(p, c) => {
                            return p?.reoccurring !== c?.reoccurring || p?.adjustmentDirection !== c?.adjustmentDirection
                        }}>
                            {({getFieldValue}) => {

                                const adjustmentDirection = getFieldValue('adjustmentDirection');
                                const reoccurring = getFieldValue('reoccurring');

                                const formItemProps = (reoccurring && adjustmentDirection != null) ? {readOnly: true} : {}
                                return adjustmentDirection ? (<Form.Item className="m-0"
                                                                         label="Adj Amt"
                                                                         name='adjustmentAmount'
                                                                         rules={[{
                                                                             required: true,
                                                                             message: 'Missing amount'
                                                                         }]}
                                >
                                    <Input placeholder="Amount"  {...formItemProps}/>
                                </Form.Item>) : null
                            }}

                        </Form.Item>

                        <Form.Item className="m-0"
                                   name={'reoccurring'}
                                   valuePropName="checked">
                            <Checkbox onChange={handleRecurringChange}>Reoccurring</Checkbox>
                        </Form.Item>
                        <Form.Item noStyle shouldUpdate={(p, c) => {
                            return p.reoccurring !== c.reoccurring || p.adjustmentDirection !== c.adjustmentDirection
                        }}>
                            {({getFieldValue}) => {
                                const reoccurring = getFieldValue('reoccurring');
                                const adjustmentDirection = getFieldValue('adjustmentDirection');

                                return (reoccurring && adjustmentDirection != null) ? (
                                    <Form.Item
                                               name={'adjustmentList'}

                                    >
                                        <Input.TextArea style={{textAlign: 'right'}} onPaste={onPasteAppendFloat}
                                                        onBlur={onAdjustmentListBlur} autoSize
                                                        placeholder="Additional Adjustment Amounts"/>
                                    </Form.Item>
                                ) : null;
                            }}
                        </Form.Item>
                        {/*<Form.Item*/}
                        {/*className="mb-0"*/}
                        {/*name="userAnswered"*/}
                        {/*valuePropName="checked"*/}
                        {/*>*/}
                        {/*    <Checkbox*/}

                        {/*    >User Answered </Checkbox>*/}

                        {/*</Form.Item>*/}
                        {/*<Form.Item*/}
                        {/*name="adminAnswered"*/}
                        {/*valuePropName="checked"*/}
                        {/*>*/}
                        {/*    <Checkbox*/}

                        {/*    >Advisor Answered </Checkbox>*/}

                        {/*</Form.Item>*/}


                    </div>
                </div>
                <Form.Item
                    label="Card Description"
                    name="description">
                    <Input.TextArea autoSize style={{width: '100%'}}/>
                </Form.Item>
                <Form.Item

                    label="Query Text"
                    name="query">
                    <Input.TextArea autoSize style={{width: '100%'}}/>
                </Form.Item>
                <div className="d-row j-between">
                    <DeleteConfirm/>
                    <Button htmlType="submit"> Save
                        {state.saving && <LoadingOutlined className="ms-6"/>}
                    </Button>
                </div>


                <LinkToItem/>
            </Form>
        </ConfigProvider>
    );
}

export default QueryItemForm;